/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

import "slick-carousel"
import "slick-carousel/slick/slick.scss"
import "slick-carousel/slick/slick-theme.scss"

import "bootstrap"
import "@hotwired/turbo-rails"
import "controllers"
import "../stylesheets/mobile"

// INFO: There is a well-known issue with `turbo` where forms submitted via
// `form.submit()` are not handled by `turbo`, therefore, there is a workaround
// using `form.requestSubmit()` however is not supported by all browsers unless
// using a polyfill library like the one below.
//
// References:
// https://github.com/hotwired/turbo/issues/97#issuecomment-757224391
import 'form-request-submit-polyfill'
import 'flickity'
import 'flickity-imagesloaded'

import '../scripts/lightbox'
